import { render, staticRenderFns } from "./FilterProducts.vue?vue&type=template&id=1cc87a52&scoped=true&"
import script from "./FilterProducts.vue?vue&type=script&lang=js&"
export * from "./FilterProducts.vue?vue&type=script&lang=js&"
import style0 from "./FilterProducts.vue?vue&type=style&index=0&id=1cc87a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc87a52",
  null
  
)

export default component.exports